"use client";

import { useScrollThreshold } from "@/hooks/useScrollPosition";
import { usePathname } from "@/i18n/routing";
import Link from "next/link";

export interface IOffer {
  title?: null | string;
  externalLink?: null | string;
}

/**
 * OfferBanner component
 * Displays an offer banner with external link if available and not on excluded routes.
 */
export default function OfferBanner({
  offer,
  isCustomTemplate = false,
}: Readonly<{ offer: IOffer; isCustomTemplate?: boolean | null }>) {
  const pathname = usePathname();
  const showTitle=useScrollThreshold()
  return (
    <>
      {!!offer.externalLink &&
        !!offer.title &&
        !pathname.includes("/premier-residence") &&
        !pathname.includes("/serviceapartment") && (
          <Link
            className={`flex ${isCustomTemplate ? !showTitle? "h-3.5" : "h-[var(--offer-height)] py-3 max-md:h-[var(--mobile-offer-height)]" : "h-[var(--offer-height)] py-3 max-md:h-[var(--mobile-offer-height)]"} cursor-pointer items-center justify-center bg-[var(--fill-base-main)] px-5 text-xs leading-4 font-medium text-[var(--text-gray-base)] `}
            href={offer.externalLink ?? "#"}
            target="_blank"
          >
            {isCustomTemplate ? showTitle? offer.title : "" : offer.title}
          </Link>
        )}
    </>
  );
}